// Explicit from/to range for the stats charts, alongside the model/language/site
// multi-selects. Native date inputs rather than a calendar library: two dates with no
// locale/keyboard/mobile edge cases of our own to maintain, and the backend already
// speaks the same YYYY-MM-DD wire format these emit.
export function DateRangePicker({
  from,
  to,
  onChange,
}: {
  from: string
  to: string
  onChange: (from: string, to: string) => void
}) {
  const inputClass =
    'rounded-lg border border-line bg-card px-2 py-1.5 text-sm text-ink focus:outline-none focus:ring-2 focus:ring-amber'
  return (
    <span className="inline-flex items-center gap-2">
      <input
        type="date"
        aria-label="Van datum"
        className={inputClass}
        value={from}
        max={to || undefined}
        onChange={(e) => onChange(e.target.value, to)}
      />
      <span className="text-xs text-ink-soft">t/m</span>
      <input
        type="date"
        aria-label="Tot datum"
        className={inputClass}
        value={to}
        min={from || undefined}
        onChange={(e) => onChange(from, e.target.value)}
      />
      {(from || to) && (
        <button
          type="button"
          onClick={() => onChange('', '')}
          className="text-xs text-ink-soft underline hover:text-ink"
        >
          Wissen
        </button>
      )}
    </span>
  )
}
